/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LiquiditySubtractOptions,
  LiquiditySubtractStatus201,
  LiquiditySubtractStatus400,
  LiquiditySubtractStatus401,
  LiquiditySubtractStatus404,
  LiquiditySubtractStatus409,
  LiquiditySubtractStatus500,
} from '../types/LiquiditySubtract'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { liquiditySubtract } from '../clients/liquiditySubtract'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const liquiditySubtractMutationKey = () =>
  [{ url: '/v1/liquidity/pool/:pool_id/remove' }] as const

export function liquiditySubtractMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = liquiditySubtractMutationKey()
  return mutationOptions<
    LiquiditySubtractStatus201,
    ResponseErrorConfig<
      | LiquiditySubtractStatus400
      | LiquiditySubtractStatus401
      | LiquiditySubtractStatus404
      | LiquiditySubtractStatus409
      | LiquiditySubtractStatus500
    >,
    LiquiditySubtractOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return liquiditySubtract({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Subtract liquidity from a pool
 * {@link /v1/liquidity/pool/:pool_id/remove}
 */
export function useLiquiditySubtract<TContext>(
  options: {
    mutation?: UseMutationOptions<
      LiquiditySubtractStatus201,
      ResponseErrorConfig<
        | LiquiditySubtractStatus400
        | LiquiditySubtractStatus401
        | LiquiditySubtractStatus404
        | LiquiditySubtractStatus409
        | LiquiditySubtractStatus500
      >,
      LiquiditySubtractOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? liquiditySubtractMutationKey()

  const baseOptions = liquiditySubtractMutationOptions(config) as UseMutationOptions<
    LiquiditySubtractStatus201,
    ResponseErrorConfig<
      | LiquiditySubtractStatus400
      | LiquiditySubtractStatus401
      | LiquiditySubtractStatus404
      | LiquiditySubtractStatus409
      | LiquiditySubtractStatus500
    >,
    LiquiditySubtractOptions,
    TContext
  >

  return useMutation<
    LiquiditySubtractStatus201,
    ResponseErrorConfig<
      | LiquiditySubtractStatus400
      | LiquiditySubtractStatus401
      | LiquiditySubtractStatus404
      | LiquiditySubtractStatus409
      | LiquiditySubtractStatus500
    >,
    LiquiditySubtractOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    LiquiditySubtractStatus201,
    ResponseErrorConfig<
      | LiquiditySubtractStatus400
      | LiquiditySubtractStatus401
      | LiquiditySubtractStatus404
      | LiquiditySubtractStatus409
      | LiquiditySubtractStatus500
    >,
    LiquiditySubtractOptions,
    TContext
  >
}
